import { render, staticRenderFns } from "./PlatformItem.vue?vue&type=template&id=3ab607b0&scoped=true&"
import script from "./PlatformItem.vue?vue&type=script&lang=js&"
export * from "./PlatformItem.vue?vue&type=script&lang=js&"
import style0 from "./PlatformItem.vue?vue&type=style&index=0&id=3ab607b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab607b0",
  null
  
)

export default component.exports